import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetByIdEntitiesUseCaseInterface } from 'domain/usecases';

export class RemoteGetByIdEntities implements GetByIdEntitiesUseCaseInterface {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetByIdEntitiesUseCaseInterface.Result>,
  ) {}

  async execute(
    params: GetByIdEntitiesUseCaseInterface.Params,
  ): Promise<GetByIdEntitiesUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: this.url + '/' + params.id,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
